import { useQuery } from '@tanstack/react-query';
import { QUERY_KEYS } from '@/utils/query-keys';
import { ActionPlansService } from '@/infra/services/action-plans';

interface GetReportsWithActionPlansCountParams {
	organization_id: string;
	company_id: string;
	sector_id?: string;
	line_id?: string;
	workstation_id?: string;
	start_date?: string;
	end_date?: string;
}

const Service = ActionPlansService.getInstance();

export const useGetReportsWithActionPlansCount = (params: GetReportsWithActionPlansCountParams) => {
	return useQuery({
		queryKey: [QUERY_KEYS.GET_ACTION_PLANS_COUNT_BY_REPORTS, params],
		queryFn: async () => Service.findAllReportsWitchActionPlansCount(params),
		enabled: Boolean(params.organization_id)
	});
};
